import React from 'react';
import InformationTooltip from 'components/atoms/information-tooltip';
import InformationRoundedIcon from 'components/atoms/icons/information-rounded';

import s from './styles.module.scss';

import type { ICondition } from 'infrastructure/interfaces';
import type { PatientIcdCode } from 'infrastructure/classes/patient-icd-code';

interface IProps {
  conditions?: ICondition[] | PatientIcdCode[];
}

const ConditionsInfoTooltip: React.FC<IProps> = ({ conditions }) => {
  const tooltipContent = conditions?.map((condition) => (
    <div key={condition.icdCode.code}>
      <p className={s.code}>{condition.icdCode.code}</p>
      <p>{condition.description}</p>
    </div>
  ));

  return (
    <div onClick={(e) => e.stopPropagation()}>
      {!!tooltipContent?.length && (
        <InformationTooltip
          content={tooltipContent}
          contentWrapperClassName={s['information-content-wrapper']}
          contentClassName={s['information-content']}
          closable={false}
          icon={
            <InformationRoundedIcon width={24} height={24} className={s.icon} />
          }
        />
      )}
    </div>
  );
};
export default ConditionsInfoTooltip;
